import React, { useEffect, useRef, useState } from "react";
//import { useDispatch } from "react-redux";
import { useDispatch, useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import "../../../assets/topstudio/styles/Player.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import axiosInstance from "../../../utils/axiosInstance";
import { setUserData } from "../../../store/userSlice";
import Volume from "./Volume";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import TrapRules from "./pop-up/trap-rules";
import TrapResult from "./tp-result/TrapResult.jsx";

const RATE_VAL = "500,000";
const TOTAL_SECONDS = 30;

const TRAP_DATA_KEYS = {
  rate: "Trap_virtual",
  results: "Trap_virtual_Results"
};

function normalizeRedisRow(raw) {
  if (raw == null || raw === "") return null;
  if (Array.isArray(raw)) return raw[0] ?? null;
  return raw;
}

function normalizeTrapRecentResults(raw) {
  if (raw == null || raw === "") return [];
  if (Array.isArray(raw)) return raw.map((v) => String(v).trim()).filter(Boolean);
  if (typeof raw === "object") {
    return Object.keys(raw)
      .sort((a, b) => Number(b) - Number(a))
      .map((k) => String(raw[k]).trim())
      .filter(Boolean);
  }
  if (typeof raw === "string") {
    return raw.split(",").map((s) => s.trim()).filter(Boolean);
  }
  return [];
}

function isTrapCardCodeAvailable(code) {
  if (code == null || code === "") return false;
  const trimmed = String(code).trim();
  return trimmed.length >= 3 && trimmed !== "1" && trimmed.toUpperCase() !== "NOT AVAILABLE";
}

function parseTrapCardField(value) {
  if (value == null || value === "") return [];
  return String(value)
    .split(",")
    .map((s) => s.trim())
    .filter(isTrapCardCodeAvailable);
}

const TRAP_CARD_POINTS = {
  A: 1, "2": 2, "3": 3, "4": 4, "5": 5, "6": 6,
  "7": 7, "8": 8, "9": 9, "10": 10, J: 11, Q: 12, K: 13
};

function trapCardPoints(code) {
  if (!isTrapCardCodeAvailable(code)) return 0;
  const rank = String(code).trim().slice(0, -2);
  return TRAP_CARD_POINTS[rank] ?? 0;
}

function calcTrapScore(cards) {
  if (!cards || cards.length === 0) return null;
  const total = cards.reduce((sum, c) => sum + trapCardPoints(c), 0);
  return total > 0 ? total : null;
}

function resultChipLabel(val) {
  const s = String(val ?? "").toUpperCase();
  if (s === "1" || s.includes("PLAYER A")) return "A";
  if (s === "2" || s.includes("PLAYER B")) return "B";
  if (s === "A" || s === "B") return s;
  return val != null && val !== "" ? String(val) : "-";
}

export default function Trap() {
  const dispatch = useDispatch();
  const [stakeLimit, setStakeLimit] = useState(0);
  const [open, setOpen] = useState(false);
  const [showRules, setShowRules] = useState(false);
  const [displayLoader, setDisplayLoader] = useState(true);
  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [betButtonShow] = useState(true);
  const [betButtonShowLoaderShow] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const [resultData, setResultData] = useState([]);
  const [resultList, setResultList] = useState([]);
  const [placedBets, setPlacedBets] = useState([]);
  const [initialBetsFetched, setInitialBetsFetched] = useState(false);
  const [roundId, setRoundId] = useState("");
  const [lastStatus, setLastStatus] = useState(null);
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const [usersOnline, setUsersOnline] = useState(0);

  const [b1, setB1] = useState(0);
  const [l1, setL1] = useState(0);
  const [playerABook, setPlayerABook] = useState(null);
  const [playerBBook, setPlayerBBook] = useState(null);
  const [winnerA, setWinnerA] = useState(false);
  const [winnerB, setWinnerB] = useState(false);
  const [revealCountA, setRevealCountA] = useState(0);
  const [revealCountB, setRevealCountB] = useState(0);

  const localTimerRef = useRef(null);
  const cardRevealTimers = useRef([]);
  const prevRoundRef = useRef(null);
  const prevCardKeyRef = useRef("");
  const [isNarrowViewport, setIsNarrowViewport] = useState(
    () => typeof window !== "undefined" && window.innerWidth <= 768
  );
  const useMobileBetSlip = isMobile || isNarrowViewport;

  const { data, isConnected } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: TRAP_DATA_KEYS.rate
  });

  console.log("Data: ", data);
  const socketPayload = data?.data;
  const payload = normalizeRedisRow(socketPayload?.data);
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  const payloadResult = socketPayload?.result;

  const playerACards = parseTrapCardField(payload?.ac1);
  const playerBCards = parseTrapCardField(payload?.ac2);

  const scoreA =
    revealCountA >= playerACards.length && playerACards.length > 0
      ? calcTrapScore(playerACards) ?? ""
      : "";
  const scoreB =
    revealCountB >= playerBCards.length && playerBCards.length > 0
      ? calcTrapScore(playerBCards) ?? ""
      : "";

  const showBetfairBetSlip = (bettype, teamname, selectRnr, price) => {
    const betObj = {
      amount: 0,
      catmid: payload?.cat_mid,
      round: payload?.cat_mid,
      market_type: "m",
      game_name: "trap_virtual",
      odds: price,
      teamname,
      bettype,
      selectRnr: selectRnr,
      marketVal: 1,
      game_type: 7
    };

    setPlaceBetObject(betObj);
    setBetErrorMessage({});
    if (useMobileBetSlip) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
  };

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;

    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );

      if (response.data?.status != null) {
        const messageObj = { message: response.data.message };
        if (response.data.status) {
          messageObj.status = true;
          setShowBetSlipPopup(false);
          setShowBetSlip(false);
          getPlacedBets();
          getBook();
        } else {
          messageObj.status = false;
        }
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      if (error.response?.data?.status === false) {
        setBetErrorMessage({
          status: false,
          message: error.response.data.message
        });
      }
    }
  };

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  const closeBetSlip = () => {
    setShowBetSlip(false);
    setBetErrorMessage({});
  };

  async function getBook() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "trap_virtual"
    });
    const books = res?.data;
    if (books?.length > 0) {
      for (let i = 0; i < books.length; i++) {
        const obj = books[i];
        if (obj.Type === "main") {
          setPlayerABook(obj.PlayerA);
          setPlayerBBook(obj.PlayerB);
        }
      }
    }
  }

  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.cat_mid,
      gametype: "trap_virtual"
    });
    setPlacedBets(res.data || []);
  }

  const fetchProfile = async () => {
    try {
      const { data: profile } = await axiosInstance.get("/profile");
      setProfileData(profile);
    } catch (e) {
      console.log("Failed to load profile data:", e);
    }
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const displayRunnerName = (runnerName) => {
    return runnerName.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  useEffect(() => {
    if (!payload) return;
    if (data?.user) dispatch(setUserData(data.user));
    updateUserData(data?.user);
    setDisplayLoader(false);

    if (lastStatus !== payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]);
      setWinnerA(false);
      setWinnerB(false);
      setPlayerABook(null);
      setPlayerBBook(null);
    }
    if (lastStatus !== payload.evt_status) setLastStatus(payload.evt_status);

    setB1(payload?.b1 ?? 0);
    setL1(payload?.l1 ?? 0);
    setRoundId(payload?.cat_mid ?? payload?.evt_id ?? "");
    setUsersOnline(payload?.users_online ?? payload?.users_count ?? 0);

    const res = payload?.result;
    setWinnerA(res === 1 || res === "1" || String(res).toUpperCase() === "A");
    setWinnerB(res === 2 || res === "2" || String(res).toUpperCase() === "B");

    const sec = Number(payload?.left_time);
    if (!Number.isNaN(sec)) {
      setTimeLeft(sec);
    }

    clearInterval(localTimerRef.current);
    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload, data?.user, dispatch, lastStatus]);

  useEffect(() => {
    if (payloadResult == null || payloadResult === "") return;
    setResultList(normalizeTrapRecentResults(payloadResult));
  }, [payloadResult]);

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
    return () => clearInterval(localTimerRef.current);
  }, []);

  useEffect(() => {
    const onResize = () => setIsNarrowViewport(window.innerWidth <= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (!initialBetsFetched && payload?.cat_mid) {
      getPlacedBets();
      getBook();
      setInitialBetsFetched(true);
    }
  }, [payload]);

  // Sequential interleaved card reveal: A1 → B1 → A2 → B2 → ...
  useEffect(() => {
    const currentRound = payload?.cat_mid;
    const cardKey = `${payload?.ac1 ?? ""}|${payload?.ac2 ?? ""}`;

    // New round — reset everything
    if (currentRound && currentRound !== prevRoundRef.current) {
      cardRevealTimers.current.forEach(clearTimeout);
      cardRevealTimers.current = [];
      setRevealCountA(0);
      setRevealCountB(0);
      prevRoundRef.current = currentRound;
      prevCardKeyRef.current = "";
    }

    // Cards changed — start reveal from scratch for this set
    if (cardKey !== prevCardKeyRef.current && (payload?.ac1 || payload?.ac2)) {
      prevCardKeyRef.current = cardKey;
      cardRevealTimers.current.forEach(clearTimeout);
      cardRevealTimers.current = [];
      setRevealCountA(0);
      setRevealCountB(0);

      const cardsA = parseTrapCardField(payload?.ac1);
      const cardsB = parseTrapCardField(payload?.ac2);
      const maxLen = Math.max(cardsA.length, cardsB.length);
      let delay = 300; // initial pause before first card
      for (let i = 0; i < maxLen; i++) {
        if (i < cardsA.length) {
          const count = i + 1;
          const t = setTimeout(() => setRevealCountA(count), delay);
          cardRevealTimers.current.push(t);
          delay += 1000;
        }
        if (i < cardsB.length) {
          const count = i + 1;
          const t = setTimeout(() => setRevealCountB(count), delay);
          cardRevealTimers.current.push(t);
          delay += 1000;
        }
      }
    }
  }, [payload?.cat_mid, payload?.ac1, payload?.ac2]);

  // Cleanup timers on unmount
  useEffect(() => {
    return () => cardRevealTimers.current.forEach(clearTimeout);
  }, []);

  /*const showResultDetail = async () => {
    try {
      const response = await axiosInstance.post("/teenpatti-results", {
        game_type: TRAP_DATA_KEYS.rate
      });
      setResultData(response.data.results_list || []);
    } catch {
      setResultData([]);
    }
  };*/

  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "Trap_virtual";

    console.log("BEFORE API CALL");

    const response = await axiosInstance.post("/teenpatti-results", resultObj);
    console.log("FULL RESPONSE", response.data);
    console.log("AFTER API CALL");

    setResultData(response.data.results_list);
    console.log("response->", resultData);
  };

  const activeTab = (tab) => {
    setActiveTabIndex(tab);
    if (tab === 2) showResultDetail();
  };

  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <div className="aviator-scope trap-scope player-scope aviator-bg-black">
      <ClientLayoutWithOutHeader showLoader={false}>
        <div className="details-tabs-wrapper1">
          <div className="main-page">
            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="bodyheight">
                  <div className="wrapper">
                    <TPStudioSidebar open={open} />
                  </div>

                  <div className="lobby-ctn BPGmaindiv">
                    <TpStudioHeader setOpen={setOpen} open={open} />
                    <TpStudioLoader displayLoader={displayLoader} />
                  </div>

                  <div
                    className="row"
                    style={{ display: displayLoader ? "none" : "" }}
                  >
                    <div className="col-md-8">
                      <div className="left-content">
                        <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                          <div className="col-6 col-md-6 titlebarname inline-block Gameidcol mt-2">
                            <p>TRAP</p>
                          </div>
                          <div
                            className="col-6 col-md-6 inline-block Gameidcol text-right"
                            style={{ marginTop: "4px" }}
                          >
                            <div
                              role="group"
                              className="btn-group btn-group-sm mr-2"
                            >
                              <button
                                type="button"
                                className={
                                  activeTabIndex === 1
                                    ? "tablink btn btn-primary bbactive"
                                    : "tablink btn btn-primary"
                                }
                                onClick={() => activeTab(1)}
                              >
                                Game
                              </button>
                              <button
                                type="button"
                                className={
                                  activeTabIndex === 2
                                    ? "tablink btn btn-primary bbactive"
                                    : "tablink btn btn-primary"
                                }
                                onClick={() => activeTab(2)}
                              >
                                Results
                              </button>
                              <button
                                type="button"
                                className="tablink btn btn-primary"
                                onClick={() => setShowRules(true)}
                              >
                                Rules
                              </button>
                            </div>
                          </div>
                        </div>

                        <TrapRules
                          show={showRules}
                          onClose={() => setShowRules(false)}
                        />

                        {activeTabIndex === 1 && (
                          <>
                            <div className="cards-layout blackjack">
                              <div
                                className="col-12 timerDiv2"
                                style={{ paddingLeft: 0 }}
                              >
                                <div className="Connectedclients mt-1">
                                  <i
                                    aria-hidden="true"
                                    className="fa fa-user mr-1"
                                    style={{ fontSize: "14px", color: "white" }}
                                  />
                                  <b>
                                    <span className="number">
                                      {usersOnline}
                                    </span>
                                  </b>
                                </div>
                                <div className="teenpatti-base-timer">
                                  <svg
                                    viewBox="0 0 100 100"
                                    className="base-timer__svg"
                                  >
                                    <g className="base-timer__circle">
                                      <circle
                                        cx="50"
                                        cy="50"
                                        r="45"
                                        className="base-timer__path-elapsed"
                                      />
                                      <path
                                        strokeDasharray={`${Math.round(
                                          dash
                                        )} ${Math.round(CIRC)}`}
                                        className={`base-timer__path-remaining ${timerColor}`}
                                        d="M 50, 50 m -45, 0 a 45,45 0 1,0 90,0 a 45,45 0 1,0 -90,0"
                                      />
                                    </g>
                                  </svg>
                                  <span className="base-timer__label">
                                    {timeLeft <= 1 ? 0 : timeLeft}
                                  </span>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-12 trap-players-stack">
                                  <div
                                    className={`trap-player-row${winnerA ? " trap-player-row--active" : ""
                                      }`}
                                  >
                                    <span className="trap-player-label">
                                      Player A
                                      {scoreA !== "" ? ` = ${scoreA}` : ""}
                                    </span>
                                    <div className="trap-player-card-box">
                                      <div className="BFBCardFanViewab wrap_flex">
                                        {playerACards.map((code, i) =>
                                          i < revealCountA ? (
                                            <img
                                              key={`a-${i}-${code}`}
                                              src={`/assets/images/cards/${code}.svg`}
                                              className="trap-card-img animate__animated animate__flipInY"
                                              draggable={false}
                                              style={{
                                                width: isMobile
                                                  ? "46px"
                                                  : "50px",
                                                height: isMobile
                                                  ? "55px"
                                                  : "65px"
                                              }}
                                            />
                                          ) : null
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className={`trap-player-row${winnerB ? " trap-player-row--active" : ""
                                      }`}
                                  >
                                    <span className="trap-player-label">
                                      Player B
                                      {scoreB !== "" ? ` = ${scoreB}` : ""}
                                    </span>
                                    <div className="trap-player-card-box">
                                      <div className="BFBCardFanViewab wrap_flex">
                                        {playerBCards.map((code, i) =>
                                          i < revealCountB ? (
                                            <img
                                              key={`b-${i}-${code}`}
                                              src={`/assets/images/cards/${code}.svg`}
                                              className="trap-card-img animate__animated animate__flipInY"
                                              draggable={false}
                                              style={{
                                                width: isMobile
                                                  ? "46px"
                                                  : "50px",
                                                height: isMobile
                                                  ? "55px"
                                                  : "65px"
                                              }}
                                            />
                                          ) : null
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="trap-volume-wrapper">
                                    <Volume />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <center>
                              <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                                <div className="buttons-div">
                                  {resultList.map((result, idx) => (
                                    <button
                                      key={`trap-res-${idx}`}
                                      type="button"
                                      className="video-button border-gradient-btn border-gradient-purple-btn trap-result-chip"
                                    >
                                      {resultChipLabel(result)}
                                    </button>
                                  ))}
                                </div>
                                <div className="round-div">
                                  <div className="label">Round ID:</div>
                                  <div className="id">{roundId}</div>
                                </div>
                              </div>
                            </center>

                            <div
                              className="tb-content"
                              style={{ background: "#fff" }}
                            >
                              <div className="market-titlebar">
                                <p className="market-name">
                                  <span className="market-name-badge">
                                    <i className="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        alt=""
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>MATCH ODDS</span>
                                  </span>
                                </p>
                                <div className="market-overarround">
                                  <span />
                                  <strong>Back</strong>
                                </div>
                                <div className="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>

                              {/* Player A — clickable Back / Lay */}
                              <div
                                className="runner-runner"
                                style={{ height: "auto" }}
                              >
                                <h3
                                  className={
                                    winnerA
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                  id="b1Sucess"
                                >
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: 700
                                                }}
                                                className="clippable-spacer"
                                              >
                                                {payload?.cat_rnr1 ||
                                                  "Player A"}
                                              </h4>
                                            </td>
                                          </tr>
                                          {playerABook !== 0 &&
                                            playerABook != null && (
                                              <tr>
                                                <td>
                                                  <div
                                                    id="bstatus1"
                                                    style={{
                                                      float: "left",
                                                      fontWeight: 600,
                                                      color:
                                                        playerABook > 0
                                                          ? "green"
                                                          : "red"
                                                    }}
                                                  >
                                                    {formatTruncate(
                                                      playerABook
                                                    )}
                                                  </div>
                                                </td>
                                              </tr>
                                            )}
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div className="runner-disabled2 suspendCls">
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "player a",
                                        "player a",
                                        b1
                                      )
                                    }
                                  >
                                    <span
                                      className="price-odd odd"
                                      id="runner1b1"
                                    >
                                      {b1}
                                    </span>
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a
                                    className="price-price price-lay mb-show span1details"
                                    id="runner1l1span"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "l",
                                        "player a",
                                        "player a",
                                        l1
                                      )
                                    }
                                  >
                                    <span
                                      className="price-odd odd"
                                      id="runner1l1"
                                    >
                                      {l1}
                                    </span>
                                    <span className="price-amount" id="rate11">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              {/* Player B — display only, no odds, no clicks */}
                              <div
                                className="runner-runner trap-runner-display-only"
                                style={{ height: "auto" }}
                              >
                                <h3
                                  className={
                                    winnerB
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                  id="b2Sucess"
                                >
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: 700
                                                }}
                                                className="clippable-spacer"
                                              >
                                                {payload?.cat_rnr2 ||
                                                  "Player B"}
                                              </h4>
                                            </td>
                                          </tr>
                                          {playerBBook !== 0 &&
                                            playerBBook != null && (
                                              <tr>
                                                <td>
                                                  <div
                                                    id="bstatus2"
                                                    style={{
                                                      float: "left",
                                                      fontWeight: 600,
                                                      color:
                                                        playerBBook > 0
                                                          ? "green"
                                                          : "red"
                                                    }}
                                                  >
                                                    {formatTruncate(
                                                      playerBBook
                                                    )}
                                                  </div>
                                                </td>
                                              </tr>
                                            )}
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div className="runner-disabled2 suspendCls">
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "player a",
                                        "player a",
                                        b1
                                      )
                                    }
                                  >
                                    <span
                                      className="price-odd odd"
                                      id="runner1b1"
                                    ></span>
                                    <span
                                      className="price-amount"
                                      id="rate1"
                                    ></span>
                                  </a>
                                  <a
                                    className="price-price price-lay mb-show span1details"
                                    id="runner1l1span"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "l",
                                        "player a",
                                        "player a",
                                        l1
                                      )
                                    }
                                  >
                                    <span
                                      className="price-odd odd"
                                      id="runner1l1"
                                    ></span>
                                    <span
                                      className="price-amount"
                                      id="rate11"
                                    ></span>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                                {/*<div
                                  className="price-row-box-new"
                                  aria-hidden="true"
                                >
                                  {isSuspended && (
                                    <div className="runner-disabled2 suspendCls">
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>*/}
                              </div>
                            </div>
                          </>
                        )}

                        {activeTabIndex === 2 && (
                          <TrapResult resultData={resultData} />
                        )}
                      </div>
                    </div>

                    <div className="col-md-4 mobile-margin">
                      {showBetSlipPopup && (
                        <TPPopUpBetSlip
                          closeBetSlipParent={closeBetSlipMobile}
                          betObj={placeBetObject}
                          placeBetParent={placeBet}
                          betButtonShow={betButtonShow}
                          betErrorMessageObj={betErrorMessageObj}
                          betButtonShowLoaderShow={betButtonShowLoaderShow}
                          profileData={profileData}
                        />
                      )}
                      <TeenPattisCasinoBetslipWeb
                        showBetSlip={showBetSlip}
                        placeBetObject={placeBetObject}
                        closeBetSlipParent={closeBetSlip}
                        placeBetParent={placeBet}
                        betErrorMessageObj={betErrorMessageObj}
                        profileData={profileData}
                      />
                      <div className="bets">
                        <strong>
                          Matched Bets ({placedBets.length})
                          {!isConnected && (
                            <>
                              <img
                                src={reconnecting}
                                alt="dc"
                                className="rounded disconnected"
                              />{" "}
                              DISCONNECTED
                            </>
                          )}
                        </strong>
                        <div className="betting-table">
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Runner</th>
                                <th>Price</th>
                                <th>Size</th>
                                <th />
                              </tr>
                            </thead>
                            <tbody>
                              {placedBets.map((bet, index) => {
                                console.log("MATCHED BET:", bet);

                                return (
                                  <tr
                                    key={index}
                                    style={{
                                      background:
                                        bet.type == "b"
                                          ? "#e9f6fc"
                                          : "#fce3e4"
                                    }}
                                  >
                                    <td>
                                      {displayRunnerName(bet.rnr)} - ({bet.cat_mid})
                                    </td>

                                    <td>{bet.amnt}</td>
                                    <td>{bet.rate}</td>
                                    <td></td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ClientLayoutWithOutHeader>

      <style>
        {`
          /* ── Timer ── */
          .trap-scope .teenpatti-base-timer {
            position: relative;
            width: 50px;
            height: 50px;
            margin-left: auto;
          }
          .trap-scope .teenpatti-base-timer .base-timer__svg {
            display: block;
            width: 50px;
            height: 50px;
            transform: scaleX(-1);
          }
          .trap-scope .teenpatti-base-timer .base-timer__circle { fill: none; stroke: none; }
          .trap-scope .teenpatti-base-timer .base-timer__path-elapsed { stroke-width: 7px; stroke: grey; }
          .trap-scope .teenpatti-base-timer .base-timer__path-remaining {
            stroke-width: 7px; stroke-linecap: round;
            transform: rotate(90deg); transform-origin: center;
            transition: 1s linear all; fill-rule: nonzero; stroke: currentColor;
          }
          .trap-scope .teenpatti-base-timer .base-timer__path-remaining.green  { color: #41b883; }
          .trap-scope .teenpatti-base-timer .base-timer__path-remaining.orange { color: #ffa500; }
          .trap-scope .teenpatti-base-timer .base-timer__path-remaining.red    { color: #f00; }
          .trap-scope .teenpatti-base-timer .base-timer__label {
            position: absolute; top: 0; left: 0;
            width: 50px; height: 50px;
            display: flex; align-items: center; justify-content: center;
            font-size: 18px; color: #fff;
            margin: 0; padding: 0; line-height: 1;
          }

          /* ── Card images ── */
          .trap-scope .trap-card-img {
            width: 46px;
            height: auto;
            display: block;
            border-radius: 4px;
            flex-shrink: 0;
          }

          /* ── Card area ── */
          .trap-scope .cards-layout.blackjack {
            position: relative;
            min-height: 210px;
            background: #000000 !important;
          }
          .trap-scope .cards-layout.blackjack::before {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background: radial-gradient(
              ellipse 100% 44% at 50% calc(30% + 60px),
              rgba(62, 193, 65, 0.95) 0%,
              rgba(62, 193, 65, 0.8) 15%,
              rgba(30, 80, 35, 0.5) 40%,
              #1e1e1e 55%,
              #1e1e1e 100%
            );
            opacity: 0.4;
            pointer-events: none;
            z-index: 0;
          }
          .trap-scope .cards-layout.blackjack > * {
            position: relative;
            z-index: 1;
          }
          .trap-scope .blackjack {
            background: #000000 !important;
          }
          .trap-scope .trap-players-stack {
            display: flex; flex-direction: column; gap: 10px;
            width: 100%; padding: 0 8px 8px;
          }
          .trap-scope .trap-player-row {
            width: 100%;
            text-align: center;
            padding-left: 10px;
            padding-right: 10px;
          }
          .trap-scope .trap-player-label {
            display: block; color: #d7bc7b; font-size: 12px;
            font-weight: 700; margin-bottom: 6px;
          }
          .trap-scope .blackjack .player-item .player-card {
            border-radius: 12px;
            border: 1px solid rgba(178, 220, 175, .25);
            background: transparent;
          }
          .trap-scope .trap-player-card-box {
            border-radius: 12px;
            border: 1px solid rgba(178, 220, 175, .25);
            background: transparent;
            padding: 8px 12px; min-height: 72px;
            display: flex; align-items: center; justify-content: center;
            flex-wrap: wrap; gap: 4px;
          }
          .trap-scope .trap-player-row--active .trap-player-card-box {
            box-shadow: 0 0 18px rgba(76,175,80,0.35);
            border-color: rgba(76,175,80,0.5);
          }
          .trap-scope .BFBCardFanViewab {
            display: flex; gap: 6px; justify-content: center; flex-wrap: wrap;
          }
          .trap-scope .trap-volume-wrapper {
            text-align: right;
            margin-right: 12px;
            margin-top: 24px;
          }
          .trap-scope .trap-volume-wrapper .sound-icon {
            transform: scale(0.9) translateX(-10px);
            transform-origin: center;
          }

          /* ── Result chips ── */
          .trap-scope .trap-result-chip { background: #4a4a4a !important; color: #fff !important; }
          .trap-scope .video-button { height: 30px !important; width: 40px !important; }

          /* ── Runner display only ── */
          .trap-scope .trap-runner-display-only { pointer-events: none; user-select: none; }

          /* ── Suspended overlay ── */
          .trap-scope .price-row-box-new { position: relative; }
          .trap-scope .runner-disabled2 {
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0;
            display: flex; align-items: center; justify-content: center;
            background: #ececed;
            color: #f00; 
            text-transform: uppercase; z-index: 10;
          }

          /* ── Results tab ── */
          .trap-scope .trap-result-card {
            border: 1px solid #ccc; border-radius: 8px; padding: 10px;
            margin-bottom: 8px; background: linear-gradient(180deg,#0f0f0f,#fbfbfb); color: #fff;
          }
          .trap-scope .trap-result-card-header {
            font-weight: bold; font-size: 16px; margin-bottom: 8px; border-bottom: 1px solid #000;
          }
          .trap-scope .trap-result-players { display: flex; flex-direction: column; gap: 16px; }
          .trap-scope .trap-result-player { text-align: center; }
          .trap-scope .trap-result-cards { display: flex; gap: 4px; justify-content: center; flex-wrap: wrap; }
          .trap-scope .trap-result-status { font-weight: bold; margin-top: 6px; color: #d7bc7b; }

          /* ── Mobile ── */
          @media (max-width: 576px) {
            .trap-scope .timerDiv2 .Connectedclients {
              margin-left: 10px;
            }
            .trap-scope .col-md-4 { margin-top: 10px; }
            .trap-scope .trap-card-img { width: 36px; }
            .trap-scope .trap-player-card-box { min-height: 55px; padding: 6px 8px; }
            .trap-scope .trap-players-stack { gap: 6px; padding: 0 4px 6px; }
          }
        `}
      </style>
    </div>
  );
}
